'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'megaphone';
var width = 512;
var height = 512;
var aliases = [128227];
var unicode = 'f675';
var svgPathData = ['M48 236.4l0 39.3 416 117 0-273.3-416 117z', 'M488 32c-13.3 0-24 10.7-24 24l0 13.5-416 117 0-2.5c0-13.3-10.7-24-24-24S0 170.7 0 184L0 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-2.5 86.3 24.3c-4.1 10.6-6.3 22.2-6.3 34.2 0 53 43 96 96 96 47 0 86.2-33.8 94.4-78.5l145.6 41 0 13.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24zM464 392.6l-416-117 0-39.3 416-117 0 273.3zm-192.2-4.2c-2.2 24.4-22.8 43.6-47.8 43.6-26.5 0-48-21.5-48-48 0-7.6 1.8-14.8 4.9-21.1l90.9 25.6z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMegaphone = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;